import { MaterialIcon } from "@website/icons/material";
import { deepCompare } from "@website/utils/deep-compare";
import { ReserveCommentPointsPropertiesType } from "@website/widget/reserve-comment/reserve-comment-points/reserve-points.types";
import { memo } from "react";

const Component = ({
  properties
}: {
  properties: ReserveCommentPointsPropertiesType;
}) => {
  const { message, type } = properties;

  return (
    <div className="text-caption md:text-body-2 flex flex-col items-start gap-1 md:flex-row md:items-center md:gap-6 md:pr-4 md:ltr:pl-4">
      <div className="flex w-[115px] flex-row items-center gap-1 md:w-[20px] md:justify-center">
        {type === "strengths" ? (
          <>
            <MaterialIcon
              className="text-ventures-snapp md:text-headline-6"
              name="thumb_up"
              variant="outlined"
            />
            <span className="text-ventures-snapp md:text-headline-6 text-overline md:hidden">
              نقاط قوت
            </span>
          </>
        ) : (
          <>
            <MaterialIcon
              className="text-error md:text-headline-6"
              name="thumb_down"
              variant="outlined"
            />
            <span className="text-error md:text-headline-6 text-overline md:hidden">
              نقاط ضعف
            </span>
          </>
        )}
      </div>
      <div>{message}</div>
    </div>
  );
};

export const ReserveCommentPoints = memo(Component, deepCompare);
